import type { MatterSummary } from "./api.js";

/** A React key that keeps privileged state local to one durable conversation. */
export const workspaceContextKey = (
  matter: MatterSummary | null,
  threadId: string | null,
): string => {
  const scope = matter === null ? "standalone" : `matter:${matter.id}`;
  return threadId === null ? `${scope}:new` : `${scope}:thread:${threadId}`;
};
